module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_02_sunset-c76bb2e7253cf1027ece4c6c7d4bd08b.jpg";